/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QaCheckHeaderInfo } from '../../models/qa-check-header-info';

export interface GetQaCheckerHeader$Params {
  producedMaterialId: number;
}

export function getQaCheckerHeader(http: HttpClient, rootUrl: string, params: GetQaCheckerHeader$Params, context?: HttpContext): Observable<StrictHttpResponse<QaCheckHeaderInfo>> {
  const rb = new RequestBuilder(rootUrl, getQaCheckerHeader.PATH, 'get');
  if (params) {
    rb.path('producedMaterialId', params.producedMaterialId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QaCheckHeaderInfo>;
    })
  );
}

getQaCheckerHeader.PATH = '/api/v1/QaCheck/{producedMaterialId}/GetHeaderForProducedMaterial';
